import { render, staticRenderFns } from "./IndividualRegisterFinsa.vue?vue&type=template&id=320d562a"
import script from "./IndividualRegisterFinsa.vue?vue&type=script&lang=js"
export * from "./IndividualRegisterFinsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports